import { type SVGProps } from 'react';

export const EyeIcon = (props: SVGProps<SVGSVGElement>): React.ReactElement => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M11.9999 5C7.62982 5 4.01019 7.43701 2.06928 11.686C1.97651 11.8857 1.97699 12.1147 2.0683 12.3115C4.00922 16.5625 7.62934 19 11.9999 19C16.3705 19 19.9907 16.5625 21.9306 12.314C22.0234 12.1147 22.0234 11.8853 21.9316 11.6885C19.9907 7.43799 16.3705 5 11.9999 5ZM11.9999 18C6.47846 18 3.91303 13.8906 3.02582 12C3.91059 10.1128 6.47602 6 11.9999 6C17.5214 6 20.0868 10.1094 20.9741 12C20.0893 13.8867 17.5239 18 11.9999 18Z"
        fill="currentColor"
      />
      <path
        d="M12 8C9.72363 8 8 9.7251 8 12.0015C8 14.2783 9.72363 16 12 16C14.2764 16 16 14.2769 16 12C16 9.72363 14.2764 8 12 8ZM12 15C10.2754 15 9 13.7266 9 12.0015C9 10.2764 10.2754 9 12 9C13.7246 9 15 10.2749 15 12C15 13.7251 13.7246 15 12 15Z"
        fill="currentColor"
      />
    </svg>
  );
};
